import { FC } from 'react';
import { useRouter } from 'next/compat/router';
import { APP_URL } from '../../../config';
import getTerritoryPageUrl from '../../services/pagesUrl/getTerritoryPageUrl';
import { showNotification } from '../NotificationBanner/showNotification';
import { ShareModal } from './ShareModal';
import { TSharePlatformProps, getSharePlatformProps } from './utils/getSharePlatformProps';
import { TSharingPlatform } from './types';
import { useAnalytics } from '../AnalyticsProvider/AnalyticsProvider';

type TShareTerritoryModalContainerProps = {
  territoryName: string;
};
export const ShareTerritoryModalContainer: FC<TShareTerritoryModalContainerProps> = ({ territoryName }) => {
  const router = useRouter();
  const { sendEvent } = useAnalytics();

  const territoryUrl = `${APP_URL}${getTerritoryPageUrl(router?.query?.territorySlug as string)}`;

  const shareOnExternalPlatformLinks = getSharePlatformProps({ url: territoryUrl, useTerritoryText: true });

  const copyToClipboard = () => {
    sendEvent('territory_share_url_button_click');
    navigator?.clipboard?.writeText(territoryUrl as string);
    showNotification({
      title: 'Copied',
      message: 'The url has been copied to the clipboard',
      type: 'success',
    });
  };

  const onShareButtonClick = (platform: TSharingPlatform) => {
    sendEvent('territory_share_on_platform_button_click', { platform });
  };

  return (
    <ShareModal
      title="Share this Territory"
      subTitle={`Share t/${territoryName} with your friends.`}
      url={territoryUrl}
      onCopyToClipboard={copyToClipboard}
      onShareButtonClick={onShareButtonClick}
      platformlinks={shareOnExternalPlatformLinks as TSharePlatformProps[]}
    />
  );
};
